var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white ", attrs: { show: _vm.loading } },
    [
      _c(
        "b-card",
        { attrs: { title: "Creación de lote" } },
        [
          _c(
            "b-form",
            { attrs: { "data-vv-scope": "batch-form" } },
            [
              _c("initial-section", {
                model: {
                  value: _vm.batch,
                  callback: function($$v) {
                    _vm.batch = $$v
                  },
                  expression: "batch"
                }
              }),
              _c("vs-divider"),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h5", [_vm._v("Sección jurídica")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("ListLegalQuality", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Calidad Jurídica (*)",
                            name: "jurisdiction",
                            danger: _vm.errors.has("batch-form.jurisdiction"),
                            "danger-text": _vm.errors.first(
                              "batch-form.jurisdiction"
                            ),
                            "data-vv-as": "calidad jurídica",
                            state: _vm.errors.has("batch-form.jurisdiction")
                              ? false
                              : null
                          },
                          on: { change: _vm.validateJurisdiction },
                          model: {
                            value: _vm.batch.jurisdiction,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "jurisdiction", $$v)
                            },
                            expression: "batch.jurisdiction"
                          }
                        }),
                        _c("b-form-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("batch-form.jurisdiction")
                              ) +
                              " "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.batch.jurisdiction !== _vm.validations.abandon
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de presunción (*)" } },
                          [
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                name: "presumptionDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                "data-vv-as": "fecha de presunción",
                                placeholder: "Fecha de presunción",
                                "data-cy": "presumption-date"
                              },
                              model: {
                                value: _vm.batch.presumptionDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "presumptionDate", $$v)
                                },
                                expression: "batch.presumptionDate"
                              }
                            }),
                            _vm.errors.has("batch-form.presumptionDate")
                              ? _c("div", [
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "batch-form.presumptionDate"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.batch.jurisdiction !== _vm.validations.abandon
                  ? _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de incautación" } },
                          [
                            _c("date-picker", {
                              staticClass: "w-100",
                              attrs: {
                                name: "seizure-date",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                placeholder: "Fecha de incautación",
                                "data-cy": "seizure-date"
                              },
                              model: {
                                value: _vm.batch.seizureDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "seizureDate", $$v)
                                },
                                expression: "batch.seizureDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Causa Art. Ord. 136" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "UserIcon" }
                                })
                              ],
                              1
                            ),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Causa Art. Ord. 136",
                                name: "law"
                              },
                              model: {
                                value: _vm.batch.law,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "law", $$v)
                                },
                                expression: "batch.law"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm.validations.service.includes(_vm.batch.jurisdiction)
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mt-5",
                                attrs: { name: "trade" },
                                model: {
                                  value: _vm.batch.trade,
                                  callback: function($$v) {
                                    _vm.$set(_vm.batch, "trade", $$v)
                                  },
                                  expression: "batch.trade"
                                }
                              },
                              [_vm._v(" Oficio ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.batch.trade
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Fecha de oficio (*)" } },
                              [
                                _c("date-picker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: _vm.batch.trade },
                                      expression: "{'required': batch.trade}"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  attrs: {
                                    name: "trade-date",
                                    format: "DD MMM YYYY",
                                    "value-type": "YYYY-MM-DD",
                                    type: "date",
                                    "data-vv-as": "fecha de oficio",
                                    placeholder: "Fecha de oficio",
                                    "data-cy": "trade-date"
                                  },
                                  model: {
                                    value: _vm.batch.tradeDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "tradeDate", $$v)
                                    },
                                    expression: "batch.tradeDate"
                                  }
                                }),
                                _vm.errors.has("batch-form.trade-date")
                                  ? _c("div", [
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "batch-form.trade-date"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.batch.trade
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Número de oficio" } },
                              [
                                _c(
                                  "b-input-group",
                                  { staticClass: "input-group-merge" },
                                  [
                                    _c(
                                      "b-input-group-prepend",
                                      { attrs: { "is-text": "" } },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "HashIcon" }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Número de oficio",
                                        name: "tradeNumber"
                                      },
                                      model: {
                                        value: _vm.batch.tradeNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.batch,
                                            "tradeNumber",
                                            $$v
                                          )
                                        },
                                        expression: "batch.tradeNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.batch.trade
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Aduana de oficio" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    name: "divisionId",
                                    options: _vm.lotteryCustoms,
                                    reduce: function(option) {
                                      return option.id
                                    },
                                    placeholder: "Aduana de oficio"
                                  },
                                  model: {
                                    value: _vm.batch.tradeCustom,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "tradeCustom", $$v)
                                    },
                                    expression: "batch.tradeCustom"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.batch.jurisdiction === _vm.validations.abandon
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h5", [
                        _vm._v("Información de Presunción de abandono")
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Manifiesto Nro (*)" } },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "HashIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.batch.jurisdiction ===
                                          _vm.validations.abandon
                                      },
                                      expression:
                                        "{'required': batch.jurisdiction === validations.abandon}"
                                    }
                                  ],
                                  attrs: {
                                    placeholder: "Manifiesto Nro",
                                    maxlength: "45",
                                    name: "manifestNumber",
                                    "data-vv-as": "manifiesto número",
                                    state: _vm.errors.has(
                                      "batch-form.manifestNumber"
                                    )
                                      ? false
                                      : null
                                  },
                                  model: {
                                    value: _vm.batch.manifestNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "manifestNumber", $$v)
                                    },
                                    expression: "batch.manifestNumber"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("b-form-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first(
                                      "batch-form.manifestNumber"
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de manifiesto (*)" } },
                          [
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.batch.jurisdiction ===
                                      _vm.validations.abandon
                                  },
                                  expression:
                                    "{'required': batch.jurisdiction === validations.abandon}"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                name: "manifestDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                "data-vv-as": "fecha de manifiesto",
                                placeholder: "Fecha de manifiesto",
                                "data-cy": "manifest-date"
                              },
                              model: {
                                value: _vm.batch.manifestDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "manifestDate", $$v)
                                },
                                expression: "batch.manifestDate"
                              }
                            }),
                            _vm.errors.has("batch-form.manifestDate")
                              ? _c("div", [
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "batch-form.manifestDate"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de presunción (*)" } },
                          [
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.batch.jurisdiction ===
                                      _vm.validations.abandon
                                  },
                                  expression:
                                    "{'required': batch.jurisdiction === validations.abandon}"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                name: "presumptionDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                "data-vv-as": "fecha de presunción",
                                placeholder: "Fecha de presunción",
                                "data-cy": "presumption-date-two"
                              },
                              on: { input: _vm.calculateBallotDate },
                              model: {
                                value: _vm.batch.presumptionDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "presumptionDate", $$v)
                                },
                                expression: "batch.presumptionDate"
                              }
                            }),
                            _vm.errors.has("batch-form.presumptionDate")
                              ? _c("div", [
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "batch-form.presumptionDate"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Número de papeleta de recepción" }
                          },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "HashIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  attrs: {
                                    maxlength: "45",
                                    type: "number",
                                    placeholder:
                                      "Número de papeleta de recepción",
                                    name: "ballotNumber"
                                  },
                                  model: {
                                    value: _vm.batch.ballotNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "ballotNumber", $$v)
                                    },
                                    expression: "batch.ballotNumber"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de papeleta" } },
                          [
                            _c("date-picker", {
                              staticClass: "w-100",
                              attrs: {
                                name: "ballotDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                "data-vv-as": "fecha de papeleta",
                                placeholder: "Fecha de papeleta",
                                "data-cy": "ballot-date"
                              },
                              on: { input: _vm.calculatePresumptionDate },
                              model: {
                                value: _vm.batch.ballotDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "ballotDate", $$v)
                                },
                                expression: "batch.ballotDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.batch.jurisdiction === _vm.validations.pending
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h5", [_vm._v("Información de Causa Legal Pendiente")])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Número de causa (*)" } },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "HashIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.batch.jurisdiction ===
                                          _vm.validations.pending
                                      },
                                      expression:
                                        "{'required': batch.jurisdiction === validations.pending}"
                                    }
                                  ],
                                  attrs: {
                                    maxlength: "45",
                                    placeholder: "Número de causa",
                                    name: "causeNumber",
                                    "data-vv-as": "número de causa",
                                    state: _vm.errors.has(
                                      "batch-form.causeNumber"
                                    )
                                      ? false
                                      : null
                                  },
                                  model: {
                                    value: _vm.batch.causeNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "causeNumber", $$v)
                                    },
                                    expression: "batch.causeNumber"
                                  }
                                }),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "batch-form.causeNumber"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Nombre del juzgado (*)" } },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "AwardIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.batch.jurisdiction ===
                                          _vm.validations.pending
                                      },
                                      expression:
                                        "{'required': batch.jurisdiction === validations.pending}"
                                    }
                                  ],
                                  attrs: {
                                    placeholder: "Nombre del juzgado",
                                    name: "courtName",
                                    "data-vv-as": "nombre del juzgado",
                                    state: _vm.errors.has(
                                      "batch-form.courtName"
                                    )
                                      ? false
                                      : null
                                  },
                                  model: {
                                    value: _vm.batch.courtName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.batch, "courtName", $$v)
                                    },
                                    expression: "batch.courtName"
                                  }
                                }),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("batch-form.courtName")
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.validations.resolution.includes(_vm.batch.jurisdiction) ||
              _vm.batch.confiscation
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h5", [_vm._v("Resolución")])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Número de resolución (*)" } },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "HashIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.validations.resolution.includes(
                                            _vm.batch.jurisdiction
                                          ) || _vm.batch.confiscation
                                      },
                                      expression:
                                        "{'required': validations.resolution\n                .includes(batch.jurisdiction) || batch.confiscation}"
                                    }
                                  ],
                                  attrs: {
                                    maxlength: "45",
                                    placeholder: "Número de resolución",
                                    name: "resolutionNumber",
                                    "data-vv-as": "número de resolución",
                                    state: _vm.errors.has(
                                      "batch-form.resolutionNumber"
                                    )
                                      ? false
                                      : null
                                  },
                                  model: {
                                    value: _vm.batch.resolutionNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batch,
                                        "resolutionNumber",
                                        $$v
                                      )
                                    },
                                    expression: "batch.resolutionNumber"
                                  }
                                }),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "batch-form.resolutionNumber"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de resolución (*)" } },
                          [
                            _c("date-picker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.validations.resolution.includes(
                                        _vm.batch.jurisdiction
                                      ) || _vm.batch.confiscation
                                  },
                                  expression:
                                    "{'required': validations.resolution\n                .includes(batch.jurisdiction) || batch.confiscation}"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                name: "resolutionDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                "data-vv-as": "fecha de resolución",
                                placeholder: "Fecha de resolución",
                                "data-cy": "resolution-date"
                              },
                              model: {
                                value: _vm.batch.resolutionDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "resolutionDate", $$v)
                                },
                                expression: "batch.resolutionDate"
                              }
                            }),
                            _vm.errors.has("batch-form.resolutionDate")
                              ? _c("div", [
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "batch-form.resolutionDate"
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("vs-divider"),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h5", [_vm._v("Sección mercancía")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Consignatario" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "BookmarkIcon" }
                                })
                              ],
                              1
                            ),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Consignatario",
                                name: "consignee"
                              },
                              model: {
                                value: _vm.batch.consignee,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "consignee", $$v)
                                },
                                expression: "batch.consignee"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Fecha de loteo (*)" } },
                      [
                        _c("date-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            name: "releaseDate",
                            format: "DD MMM YYYY",
                            "value-type": "YYYY-MM-DD",
                            type: "date",
                            "data-vv-as": "fecha de loteo",
                            placeholder: "Fecha de loteo",
                            "disabled-date": _vm.disabledMaxDate,
                            "data-cy": "release-date"
                          },
                          model: {
                            value: _vm.batch.releaseDate,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "releaseDate", $$v)
                            },
                            expression: "batch.releaseDate"
                          }
                        }),
                        _vm.errors.has("batch-form.releaseDate")
                          ? _c("div", [
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("batch-form.releaseDate")
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Ubicación de mercancía (*)" } },
                      [
                        _c("SelectValidate", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.optionsLocation,
                            name: "location",
                            "data-vv-as": "ubicación de mercancía",
                            danger: _vm.errors.has("batch-form.location"),
                            "danger-text": _vm.errors.first(
                              "batch-form.location"
                            ),
                            state: _vm.errors.has("batch-form.location")
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.batch.location,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "location", $$v)
                            },
                            expression: "batch.location"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Calidad de mercancía (*)" } },
                      [
                        _c("SelectValidate", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.optionsQuality,
                            name: "quality",
                            danger: _vm.errors.has("batch-form.quality"),
                            "danger-text": _vm.errors.first(
                              "batch-form.quality"
                            ),
                            "data-vv-as": "calidad de mercancía",
                            state: _vm.errors.has("batch-form.quality")
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.batch.quality,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "quality", $$v)
                            },
                            expression: "batch.quality"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("vs-divider"),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h5", [_vm._v("Visto bueno")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mt-5",
                            attrs: { name: "checkApproval" },
                            model: {
                              value: _vm.batch.check,
                              callback: function($$v) {
                                _vm.$set(_vm.batch, "check", $$v)
                              },
                              expression: "batch.check"
                            }
                          },
                          [_vm._v(" Requiere visto bueno ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.batch.check
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Número de certificado (*)" } },
                          [
                            _c(
                              "b-input-group",
                              { staticClass: "input-group-merge" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { attrs: { "is-text": "" } },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "HashIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: _vm.batch.certificateNumber
                                      },
                                      expression:
                                        "{ 'required': batch.certificateNumber }"
                                    }
                                  ],
                                  attrs: {
                                    placeholder: "Número de certificado",
                                    name: "certificateNumber",
                                    type: "number",
                                    "data-vv-as": "número de certificado",
                                    state: _vm.errors.has(
                                      "batch-form.certificateNumber"
                                    )
                                      ? false
                                      : null
                                  },
                                  model: {
                                    value: _vm.batch.certificateNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.batch,
                                        "certificateNumber",
                                        $$v
                                      )
                                    },
                                    expression: "batch.certificateNumber"
                                  }
                                }),
                                _c("b-form-invalid-feedback", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "batch-form.certificateNumber"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.batch.check
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Fecha de visto bueno" } },
                          [
                            _c("date-picker", {
                              staticClass: "w-100",
                              attrs: {
                                name: "checkDate",
                                format: "DD MMM YYYY",
                                "value-type": "YYYY-MM-DD",
                                type: "date",
                                placeholder: "Fecha de visto bueno",
                                "data-cy": "check-date"
                              },
                              model: {
                                value: _vm.batch.checkDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "checkDate", $$v)
                                },
                                expression: "batch.checkDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.batch.check
                  ? _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Entidad visto bueno (*)" } },
                          [
                            _c("SelectValidate", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: _vm.batch.check },
                                  expression: "{ 'required': batch.check }"
                                }
                              ],
                              attrs: {
                                options: _vm.optionsEntityCheck,
                                name: "entityCheck",
                                "data-vv-as": "entidad visto bueno",
                                state: _vm.errors.has("batch-form.entityCheck")
                                  ? false
                                  : null,
                                danger: _vm.errors.has(
                                  "batch-form.entityCheck"
                                ),
                                "danger-text": _vm.errors.first(
                                  "batch-form.entityCheck"
                                )
                              },
                              model: {
                                value: _vm.batch.entityCheck,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "entityCheck", $$v)
                                },
                                expression: "batch.entityCheck"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("vs-divider"),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h5", [_vm._v("Sección montos y derechos")])
                ]),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Valor aduanero (*)" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c(
                                  "small",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("USD")]
                                )
                              ]
                            ),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                type: "number",
                                placeholder: "Valor aduanero",
                                name: "customsAmount",
                                "data-vv-as": "valor aduanero",
                                state: _vm.errors.has(
                                  "batch-form.customsAmount"
                                )
                                  ? false
                                  : null
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calculateTax()
                                }
                              },
                              model: {
                                value: _vm.batch.customsAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "customsAmount", $$v)
                                },
                                expression: "batch.customsAmount"
                              }
                            }),
                            _c("b-form-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("batch-form.customsAmount")
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Derechos arancelarios" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c(
                                  "small",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("USD")]
                                )
                              ]
                            ),
                            _c("b-form-input", {
                              attrs: {
                                readonly: "",
                                placeholder: "Derechos arancelarios",
                                name: "lawsAmount"
                              },
                              model: {
                                value: _vm.batch.lawsAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "lawsAmount", $$v)
                                },
                                expression: "batch.lawsAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Tipo de cambio" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c(
                                  "small",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("CLP")]
                                )
                              ]
                            ),
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                placeholder: "Tipo de cambio",
                                name: "exchangeAmount"
                              },
                              model: {
                                value: _vm.batch.exchangeAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "exchangeAmount", $$v)
                                },
                                expression: "batch.exchangeAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Monto mínimo" } },
                      [
                        _c(
                          "b-input-group",
                          { staticClass: "input-group-merge" },
                          [
                            _c(
                              "b-input-group-prepend",
                              { attrs: { "is-text": "" } },
                              [
                                _c(
                                  "small",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("CLP")]
                                )
                              ]
                            ),
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                placeholder: "Monto mínimo",
                                name: "minimumAmount",
                                "data-vv-as": "monto mínimo"
                              },
                              model: {
                                value: _vm.batch.minimunAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.batch, "minimunAmount", $$v)
                                },
                                expression: "batch.minimunAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Impuestos Adicionales" } },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.optionsAdditional,
                            name: "additional"
                          },
                          model: {
                            value: _vm.batch.additional,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "additional", $$v)
                            },
                            expression: "batch.additional"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("vs-divider"),
              _c("div", { staticClass: "row" }, [
                _c("h5", { staticClass: "col-12" }, [
                  _vm._v(" Sección detalle del lote ")
                ]),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("ListBatchClassification", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Clasificación del lote (*)",
                            name: "classification",
                            danger: _vm.errors.has("batch-form.classification"),
                            "danger-text": _vm.errors.first(
                              "batch-form.classification"
                            ),
                            "data-vv-as": "clasificación del lote"
                          },
                          model: {
                            value: _vm.batch.clasification,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "clasification", $$v)
                            },
                            expression: "batch.clasification"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Tipo de medida (*)" } },
                      [
                        _c("SelectValidate", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.optionsMeasure,
                            name: "measure",
                            danger: _vm.errors.has("batch-form.measure"),
                            "danger-text": _vm.errors.first(
                              "batch-form.measure"
                            ),
                            state: _vm.errors.has("batch-form.measure")
                              ? false
                              : null,
                            "data-vv-as": "tipo de medida"
                          },
                          model: {
                            value: _vm.batch.measure,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "measure", $$v)
                            },
                            expression: "batch.measure"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Peso (*)" } },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            placeholder: "Peso",
                            "data-vv-as": "peso",
                            name: "weight",
                            type: "number",
                            state: _vm.errors.has("batch-form.weight")
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.batch.weight,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "weight", $$v)
                            },
                            expression: "batch.weight"
                          }
                        }),
                        _c("b-form-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("batch-form.weight")) +
                              " "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Unidad de medida (*)" } },
                      [
                        _c("SelectValidate", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.optionsMeasureUnit,
                            "data-vv-as": "unidad de medida",
                            name: "measureUnit",
                            state: _vm.errors.has("batch-form.measureUnit")
                              ? false
                              : null,
                            danger: _vm.errors.has("batch-form.measureUnit"),
                            "danger-text": _vm.errors.first(
                              "batch-form.measureUnit"
                            )
                          },
                          model: {
                            value: _vm.batch.measureUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "measureUnit", $$v)
                            },
                            expression: "batch.measureUnit"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Núm de Lote interno (*)" } },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            placeholder: "Núm de Lote interno",
                            "data-vv-as": "núm de lote interno",
                            name: "internBatch",
                            type: "number",
                            state: _vm.errors.has("batch-form.internBatch")
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.batch.internBatch,
                            callback: function($$v) {
                              _vm.$set(_vm.batch, "internBatch", $$v)
                            },
                            expression: "batch.internBatch"
                          }
                        }),
                        _c("b-form-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("batch-form.internBatch")
                              ) +
                              " "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("label", [_vm._v("Descripción del lote (*)")]),
                    _c("b-form-textarea", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        placeholder: "Escriba aquí la descripción del lote",
                        rows: "4",
                        max: "",
                        maxlength: "5000",
                        name: "description",
                        state: _vm.errors.has("batch-form.description")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.batch.description,
                        callback: function($$v) {
                          _vm.$set(_vm.batch, "description", $$v)
                        },
                        expression: "batch.description"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("batch-form.description")) +
                          " "
                      )
                    ]),
                    _c(
                      "small",
                      {
                        staticClass: "textarea-counter-value float-right",
                        class:
                          _vm.batch.description.length >= _vm.maxChar
                            ? "bg-danger"
                            : ""
                      },
                      [
                        _c("span", { staticClass: "char-count" }, [
                          _vm._v(_vm._s(_vm.batch.description.length))
                        ]),
                        _vm._v(" / " + _vm._s(_vm.maxChar) + " ")
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("label", [_vm._v("Datos adicionales internos (*)")]),
                    _c("b-form-textarea", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        placeholder: _vm.placeholderAddData,
                        rows: "4",
                        max: "",
                        maxlength: "1000",
                        name: "descriptionInvoice",
                        "data-vv-as": "datos adicionales internos",
                        state: _vm.errors.has("batch-form.descriptionInvoice")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.batch.descriptionInvoice,
                        callback: function($$v) {
                          _vm.$set(_vm.batch, "descriptionInvoice", $$v)
                        },
                        expression: "batch.descriptionInvoice"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first("batch-form.descriptionInvoice")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "small",
                      {
                        staticClass: "textarea-counter-value float-right",
                        class:
                          _vm.batch.descriptionInvoice.length >= _vm.maxChar
                            ? "bg-danger"
                            : ""
                      },
                      [
                        _c("span", { staticClass: "char-count" }, [
                          _vm._v(_vm._s(_vm.batch.descriptionInvoice.length))
                        ]),
                        _vm._v(" / " + _vm._s(_vm.maxChar2) + " ")
                      ]
                    )
                  ],
                  1
                ),
                !_vm.editBatch
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("UploadFile", {
                              attrs: {
                                permission: "*",
                                text: "Seleccionar imagen",
                                accept: ".jpg,.png",
                                "max-size-in-mb": 30,
                                "upload-to": _vm.urlFile,
                                "button-class": "btn-block",
                                "container-class": "w-100"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.addAdditionalFile()
                                }
                              },
                              model: {
                                value: _vm.additionalImage,
                                callback: function($$v) {
                                  _vm.additionalImage = $$v
                                },
                                expression: "additionalImage"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.batch.images.length
                          ? _c(
                              "div",
                              { staticClass: "col-12 mt-3" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { hover: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c(
                                          "b-tr",
                                          [
                                            _c(
                                              "b-th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Nombre archivo")]
                                            ),
                                            _c(
                                              "b-th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Principal")]
                                            ),
                                            _c(
                                              "b-th",
                                              {
                                                staticClass: "text-center",
                                                attrs: { scope: "col" }
                                              },
                                              [_vm._v("-")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.batch.images.length
                                      ? _c(
                                          "b-tbody",
                                          _vm._l(_vm.batch.images, function(
                                            file
                                          ) {
                                            return _c(
                                              "b-tr",
                                              { key: file.id },
                                              [
                                                _c("b-td", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center"
                                                    },
                                                    [
                                                      _c("vs-icon", {
                                                        staticClass: "mr-1",
                                                        attrs: {
                                                          icon: "file_present",
                                                          size: "medium"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(file.name) +
                                                          " "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]),
                                                _c(
                                                  "b-td",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c("vs-checkbox", {
                                                      staticClass: "ml-5 pl-5",
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.markPrincipalImage(
                                                            file
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: file.principal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            file,
                                                            "principal",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "file.principal"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-td",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          variant:
                                                            "outline-danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeAdditionalFile(
                                                              file.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" remover ")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]),
              _c(
                "div",
                { staticClass: "col-12 text-right  mt-5" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.cancelBatch }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "outline-info", "data-cy": "preview" },
                      on: {
                        click: function($event) {
                          return _vm.previewBatch()
                        }
                      }
                    },
                    [_vm._v(" Previsualizar ")]
                  ),
                  _vm.batch.status === "" ||
                  _vm.batch.status === _vm.batchesCodeSates.borrador
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            variant: "outline-warning",
                            "data-cy": "draft"
                          },
                          on: {
                            click: function($event) {
                              return _vm.processBatch(
                                _vm.batchesCodeSates.borrador
                              )
                            }
                          }
                        },
                        [_vm._v(" Guardar como borrador ")]
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", "data-cy": "next-button" },
                      on: {
                        click: function($event) {
                          return _vm.processBatch(_vm.batchesCodeSates.creado)
                        }
                      }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }